// stores/useRolePlayStore.ts
import { create } from 'zustand'

interface RolePlayState {
  step: number
  purposeIds: number[]
  setPurposeIds: (list: number[]) => void
  personaId: number
  setPersonaId: (id: number) => void

  toggleSelection: (id: number) => void
  showCustomPurpose: boolean
  customPurpose: string
  background: string
  setStep: (step: number) => void
  nextStep: () => void
  prevStep: () => void
  toggleItem: (id: number) => void
  setCustomPurpose: (text: string) => void
  toggleShowCustomPurpose: () => void
  setBackground: (text: string) => void
}

export const useCreateRolePlayStore = create<RolePlayState>((set) => ({
  step: 0,
  purposeIds: [],
  setPurposeIds: (purposeIds) => set({ purposeIds: purposeIds }),

  personaId: null,
  setPersonaId: (id) => set({ personaId: id }),

  // ▶️ 멀티셀렉이었다가 아래로 싱글 셀렉으로 바꿈.
  // toggleSelection: (id) =>
  //   set((state) => {
  //     const alreadySelected = state.purposeIds.includes(id)
  //     const updatedList = alreadySelected ? state.purposeIds.filter((item) => item !== id) : [...state.purposeIds, id]
  //     return { purposeIds: updatedList }
  //   }),

  toggleSelection: (id) =>
    set((state) => {
      const alreadySelected = state.purposeIds.includes(id)
      const updatedList = alreadySelected ? [] : [id]
      return { purposeIds: updatedList }
    }),

  showCustomPurpose: false,
  customPurpose: '',
  background: '',
  setStep: (step) => set({ step }),
  nextStep: () => set((s) => ({ step: s.step + 1 })),
  prevStep: () => set((s) => ({ step: Math.max(0, s.step - 1) })),
  toggleItem: (id) =>
    set((s) =>
      s.purposeIds.includes(id)
        ? { purposeIds: s.purposeIds.filter((v) => v !== id) }
        : { purposeIds: [...s.purposeIds, id] }
    ),
  toggleShowCustomPurpose: () => set((s) => ({ showCustomPurpose: !s.showCustomPurpose })),
  setCustomPurpose: (text) => set({ customPurpose: text }),
  setBackground: (text) => set({ background: text }),
}))
